export default __webpack_public_path__ + "static/media/SG6.6af6583f.png";